__turbopack_context__.v({
  "DashboardContent": "delete-module__hV8NcW__DashboardContent",
  "dashboard": "delete-module__hV8NcW__dashboard",
  "dashboardIcon": "delete-module__hV8NcW__dashboardIcon",
  "deletStoreLinks": "delete-module__hV8NcW__deletStoreLinks",
  "editprofilebtn": "delete-module__hV8NcW__editprofilebtn",
});
